<template>
  <div class="my_input_number_layer" @mousedown.stop>
    <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" :style="{
        width: titleWidth + 'px'
      }"></span>
      <span
        v-if="isShow"
        :style="{
          width: width+ 'px',
          marginLeft: titleWidth == 0 ? 0 : 10 + 'px'
        }"
        class="input_display"
        @click="clickEvent('isShow', false)"
      >{{number + symbol}}</span>
      <el-input
        @focus="focus($event)"
        v-else
        v-model="number"
        :placeholder="placeholder"
        :disabled="disabled"
        ref="input_new"
        class="input_new"
        @blur="clickEvent('isShow', true)"
        @keyup.enter.native="clickEvent('isShow', true)"
        @keydown.up.native="keydown_up"
        @keydown.down.native="keydown_down"
        @change="change"
        @input="input_num"
        size="small"
        :min="min"
        :max="max"
        :controls="false"
        :style="{
          width: width+ 'px',
          marginLeft: titleWidth == 0 ? 0 : 10 + 'px'
        }"
      ></el-input>
    </p>
  </div>
</template>

<script>
export default {
  name: 'my_input_number_index',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: { // 输入框的值
      type: [Number, String],
      default: 0
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '70'
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    symbol: {
      type: String,
      default: 'px'
    },
    numType: {
      type: String,
      default: 'int'  // int,float
    }
  },
  data () {
    return {
      Result: this.value,
      number: this.value,
      numberTemp: this.value,
      isShow: true
    }
  },
  mounted () {
  },
  watch: {
    Result (val) {
      this.$emit('update:value', val);//双向数据绑定
    },
    value (val) {
      // this.Result = this.value
      this.number = this.value
      this.numberTemp = this.value
    }
  },
  computed: {
  },
  methods: {
    focus () {
      // event.currentTarget.select();
    },
    clickEvent (key, value) {
      this[key] = value
      if (!value) {
        this.$nextTick(() => {
          this.$refs.input_new.focus()
        })
      }
    },
    change () {
      if (this.number === '' || Number(this.number) < this.min) {
        this.number = this.min
        this.numberTemp = this.min
      }
      if (this.numType === 'float') {
        let floatReg = /^(0|[1-9][0-9]*)(\.\d+)?$/
        if (!floatReg.test(this.number)) {
          this.number = this.min
          this.numberTemp = this.min
        }
      }
      this.Result = this.number
      this.$emit('change', Number(this.Result))
    },
    blur () {
      this.$emit('blur', this.Result);
    },
    input_num (number) {
      if (number === '') {
        return
      }
      if (this.validate_num(number)) {
        this.number = number
        this.numberTemp = number
        if (number > this.max) {
          this.number = this.max
          this.numberTemp = this.max
        }
      } else {
        this.number = this.numberTemp
      }
    },
    keydown_up () {
      this.number = Number((Number(this.number) + this.step).toFixed(1))
      this.numberTemp = this.number
      if (Number(this.number) >= this.max) {
        this.number = this.max
        this.numberTemp = this.max
      }
      this.Result = this.number
      this.$emit('change', Number(this.Result))
    },
    keydown_down () {
      this.number = Number((Number(this.number) - this.step).toFixed(1))
      this.numberTemp = this.number
      if (Number(this.number) <= this.min) {
        this.number = this.min
        this.numberTemp = this.min
      }
      this.Result = this.number
      this.$emit('change', Number(this.Result))
    },
    validate_num (number) {
      let result = true
      let reg = /^(0|[1-9]\d*)$/
      if (this.numType === 'int') {
        reg = /^(0|[1-9]\d*)$/
        result = reg.test(number)
      }
      if (this.numType === 'float') {
        reg = /^\d[\d\.]*$/
        result = reg.test(number)
        if (reg.test(number)) {
          let numArr = number.split('.')
          let left = numArr[0]
          let right = numArr[1]
          if (right) {
            if (right.length > 1 || right[0] === '0') {
              result = false
            }
          }
          if (!(/^(0|[1-9]\d*)$/.test(left))) {
            result = false
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.my_input_number_layer {
  .input_display {
    font-size: 14px;
  }
  /deep/ .el-input {
    .el-input__inner {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_input_number/index.vue